// React and related imports
import { Button, Modal, Tooltip } from 'flowbite-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IQuestionnaire } from '../../common/interfaces/Questionnaire.interface';
import { getLocalizedValueFromMultiLangValues } from '../../utils/getLocalizedValueFromMultiLangValues';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  item: IQuestionnaire | null;
}

export const QuestionnaireModal: React.FC<Props> = ({
  isOpen,
  onClose,
  item,
}) => {
  const { t } = useTranslation();
  if (!item) return null;
  const body = getLocalizedValueFromMultiLangValues(item.body || '--');

  return (
    <Modal dismissible show={isOpen} onClose={onClose}>
      <Modal.Header className="modal-header">
        {body ? (
          <div>
            <h2 className="text-primary font-bold">{body}</h2>
          </div>
        ) : (
          '--'
        )}
      </Modal.Header>
      <Modal.Body className="space-y-5">
        <div>
          <h2 className="text-primary font-bold">
            {t('questionnaireLabels.questions')}:
          </h2>
          <ul className="list-disc ps-4">
            {item.questions.map((question, qIndex) => (
              <li
                key={`question-${qIndex || question.id || question.body}`}
                className="mb-2"
              >
                {question.options && question.options?.length > 0 ? (
                  <Tooltip
                    content={
                      <div className="flex flex-col gap-2">
                        <h2 className="font-bold">
                          {t('questionnaireLabels.options')}:
                        </h2>
                        {question.options.map((option, oIndex) => (
                          <div key={`option-${oIndex}`} className="mb-2">
                            {option.body &&
                              getLocalizedValueFromMultiLangValues(
                                option.body || '--'
                              )}
                          </div>
                        ))}
                      </div>
                    }
                    placement="left"
                  >
                    <Button className="btn-light max-w-sm text-start">
                      {question.body &&
                        getLocalizedValueFromMultiLangValues(
                          question.body || '--'
                        )}
                    </Button>
                  </Tooltip>
                ) : (
                  <div className="text-primary max-w-sm rounded-lg bg-gray-100 p-2 text-start text-sm">
                    {question.body &&
                      getLocalizedValueFromMultiLangValues(
                        question.body || '--'
                      )}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="text-primary font-bold">
            {t('questionnaireLabels.status')}:{' '}
            <span className="font-medium text-gray-950">
              {t(`status.${item.status}`)}
            </span>
          </h2>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" className="btn-light me-4" onClick={onClose}>
          {t('content.cancel')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
